import { ELkType } from '../../repositories/lk-type/entities/get_lk_type/GetLkTypeResponseSchema';
import { TAppState } from '../../types/appState';

export const isSearcherSelector = (state: TAppState) => {
  if (!state.lkType) {
    return true;
  }

  return state.lkType.lkType === ELkType.Searcher;
};
